import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.664 9.657A8.664 8.664 0 1 0 6.55 16.399a.79.79 0 0 0 .134.788 12.3 12.3 0 0 1 1.78 2.662q.387.76.638 1.576H8.85a.788.788 0 0 0 0 1.575h6.302a.788.788 0 0 0 0-1.575h-.252a9.3 9.3 0 0 1 .638-1.576 11.5 11.5 0 0 1 1.764-2.575.79.79 0 0 0 .15-.827 8.67 8.67 0 0 0 3.213-6.79m-15.753 0a7.09 7.09 0 1 1 11.027 5.931 6 6 0 0 1-.543.323h-6.79a7.09 7.09 0 0 1-3.694-6.254m9.224 9.452a11 11 0 0 0-.875 2.316h-2.52a11 11 0 0 0-.875-2.324 13 13 0 0 0-.968-1.615h6.198a12 12 0 0 0-.96 1.615z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.212 15.123a.788.788 0 1 0 0-1.575.788.788 0 0 0 0 1.575M13.575 14.336a.787.787 0 1 0 1.575 0 .787.787 0 0 0-1.575 0M16.726 12.76a.788.788 0 1 0 0-1.575.788.788 0 0 0 0 1.575M16.726 9.61a.788.788 0 1 0 0-1.576.788.788 0 0 0 0 1.576M13.575 12.76a.788.788 0 1 0 0-1.575.788.788 0 0 0 0 1.575"
    }, null, -1)
  ]))]))
}
export default { render: render }